import React, { useState } from 'react';
import DemandModal from '../../../components/DemandModal/DemandModal';

const CTASection: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConsultClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const sectionStyle: React.CSSProperties = {
    position: 'relative',
    padding: '0rem 0',
    paddingBottom: '10rem',
    background: '#000000',
    overflow: 'hidden',
  };

  const containerStyle: React.CSSProperties = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 2rem',
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '2.8rem',
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: '1.5rem',
    background: 'linear-gradient(135deg, #60a5fa 0%, #a855f7 50%, #ec4899 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    lineHeight: 1.2,
  };

  const descriptionStyle: React.CSSProperties = {
    fontSize: '1.25rem',
    color: '#cbd5e1',
    marginBottom: '3rem',
    lineHeight: 1.6,
    fontWeight: 300,
  };

  const ctaButtonsStyle: React.CSSProperties = {
    display: 'flex',
    gap: '1.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '4rem',
  };

  const primaryButtonStyle: React.CSSProperties = {
    background: 'linear-gradient(135deg, #60a5fa 0%, #a855f7 100%)',
    color: '#ffffff',
    padding: '1rem 2.5rem',
    borderRadius: '50px',
    border: 'none',
    fontSize: '1.125rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 10px 30px rgba(96, 165, 250, 0.3)',
    textDecoration: 'none',
    display: 'inline-block',
  };

  const secondaryButtonStyle: React.CSSProperties = {
    background: 'transparent',
    color: '#ffffff',
    padding: '1rem 2.5rem',
    borderRadius: '50px',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    fontSize: '1.125rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
  };

  const statsStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '3rem',
    marginTop: '4rem',
    flexWrap: 'wrap',
  };

  const statItemStyle: React.CSSProperties = {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // 水平居中对齐
    justifyContent: 'flex-start', // 从顶部开始
    minHeight: '120px', // 确保所有项目有相同的最小高度
    flex: '1 1 200px', // 弹性布局，最小200px
    maxWidth: '300px', // 最大宽度限制
  };

  const statNumberStyle: React.CSSProperties = {
    fontSize: '2.5rem',
    fontWeight: 700,
    color: '#60a5fa',
    marginBottom: '0.5rem',
    lineHeight: '1', // 确保数字行高一致
    height: '2.5rem', // 固定高度确保对齐
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const statLabelStyle: React.CSSProperties = {
    fontSize: '1rem',
    color: '#94a3b8',
    fontWeight: 300,
    lineHeight: '1.2', // 确保文案行高一致
    height: '1.2rem', // 固定高度确保对齐
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '0.5rem',
  };

  // 背景装饰
  const backgroundDeco1Style: React.CSSProperties = {
    position: 'absolute',
    top: '-20%',
    left: '-20%',
    width: '400px',
    height: '400px',
    background: 'radial-gradient(circle, rgba(96, 165, 250, 0.1) 0%, transparent 70%)',
    borderRadius: '50%',
    zIndex: 1,
  };

  const backgroundDeco2Style: React.CSSProperties = {
    position: 'absolute',
    bottom: '-20%',
    right: '-20%',
    width: '500px',
    height: '500px',
    background: 'radial-gradient(circle, rgba(168, 85, 247, 0.08) 0%, transparent 70%)',
    borderRadius: '50%',
    zIndex: 1,
  };

  const backgroundDeco3Style: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '800px',
    height: '800px',
    background: 'radial-gradient(circle, rgba(236, 72, 153, 0.05) 0%, transparent 70%)',
    borderRadius: '50%',
    zIndex: 1,
  };

  return (
    <>
      <style>
        {`
          .cta-primary-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 40px rgba(96, 165, 250, 0.4) !important;
            background: linear-gradient(135deg, #3b82f6 0%, #9333ea 100%) !important;
          }
          
          .cta-secondary-btn:hover {
            background: rgba(255, 255, 255, 0.1) !important;
            border-color: rgba(96, 165, 250, 0.5) !important;
            transform: translateY(-2px);
          }

          @media (max-width: 768px) {
            .cta-title {
              font-size: 2.5rem !important;
            }
            
            .cta-description {
              font-size: 1.125rem !important;
            }
            
            .cta-buttons {
              flex-direction: column !important;
              align-items: stretch !important;
            }
            
            .cta-buttons a, .cta-buttons button {
              text-align: center !important;
            }
            
            .cta-stats {
              gap: 2rem !important;
            }
          }

          @media (max-width: 480px) {
            .cta-title {
              font-size: 2rem !important;
            }
            
            .cta-container {
              padding: 0 1rem !important;
            }
            
            .cta-stats {
              flex-direction: column !important;
              align-items: center !important;
            }
          }
        `}
      </style>

      <section style={sectionStyle}>
        <div style={backgroundDeco1Style}></div>
        <div style={backgroundDeco2Style}></div>
        <div style={backgroundDeco3Style}></div>
        
        <div style={containerStyle} className="cta-container">
          <h2 style={titleStyle} className="cta-title">
             体验AI时代下的极致开发速度？
          </h2>
          
          <p style={descriptionStyle} className="cta-description">
             认准圆领自营软件开发服务，亿级流量平台开发经验。大型项目每日可视化交付，真正的敏捷开发！以极低的成本创作出高质量的APP。
          </p>
          
          <div style={ctaButtonsStyle} className="cta-buttons">
            <a 
              href="/contact" 
              style={primaryButtonStyle}
              className="cta-primary-btn"
              onClick={handleConsultClick}
            >
              立即咨询
            </a> 
          </div>
          
          <div style={statsStyle} className="cta-stats">
            <div style={statItemStyle}>
              <span style={statNumberStyle}>60-90%</span>
              <span style={statLabelStyle}>成本节省</span>
            </div>
         
            <div style={statItemStyle}>
              <span style={statNumberStyle}>可视化交付</span>
              <span style={statLabelStyle}>过程管理</span>
            </div>
            <div style={statItemStyle}>
              <span style={statNumberStyle}>5-10倍</span>
              <span style={statLabelStyle}>开发速度</span>
            </div>
          </div>
        </div>
      </section>
      
      <DemandModal 
        isOpen={isModalOpen} 
        onClose={handleModalClose} 
      />
    </>
  );
};

export default CTASection; 